let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8MIup")).then(() => parcelRequire('ctW5D'));